module.exports = __webpack_public_path__ + "img/picto3.7b70f776.svg";